/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

import {
  Card,
  FormControl,
  Grid,
  InputLabel,
  Select,
  TextField,
} from "@mui/material";
import breakpoints from "assets/theme/base/breakpoints";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import Height from "components/height/height";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { blank } from "utils/generic";
import { getScreenRight } from "utils/generic";
import { useDispatch } from "react-redux";
import { showResMsg } from "utils/generic";
import { genericMessage } from "utils/genericMessages";
import { validateField } from "utils/generic";
import { getBatVehicleById } from "utils/api";
import { addBatVehicle } from "utils/api";
import { updateBatVehicle } from "utils/api";
import { generateDataList } from "utils/generic";
import { fetchDetailsByRegistrationData } from "utils/api";
import { fetchRegistrationNumberData } from "utils/api";
import { getParameterListName } from "utils/api";
let parentId;
let fetchedData;
let VC_Id;
let LOGIN_DETAILS;

const errMsg = {
  color: `red`,
  fontSize: `11px`,
};

function AddBATVehicle() {
  const { id } = useParams();
  const { batGroupID } = useParams();
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [screenName, setScreenName] = useState("Add BAT Vehicle");
  const [category, setCategory] = useState([]);
  const [registration, setRegistration] = useState([]);
  const [vehicleCategoryErr, setVehicleCategoryErr] = useState(false);
  const [registrationNumberErr, setRegistrationNumberErr] = useState(false);
  const [cancelBtnEdit, setCancelBtnEdit] = useState(false);
  const [disableColor, setDisableColor] = useState(false);
  const [tabsOrientation, setTabsOrientation] = useState("horizontal");

  const [values, setValues] = React.useState({
    vehicleCategory: "",
    registrationNumber: "",
    vehicleManufacturingYear: "",
    vinChassisNumber: "",
    vehicleMakeModel: "",
    engineNumber: "",
  });

  LOGIN_DETAILS = JSON.parse(sessionStorage.getItem("LOGIN_DETAILS"));
  values.businessUserID = LOGIN_DETAILS.businessUserID;

  const handleChange = (name) => (event) => {
    if (
      event.target.validity !== undefined &&
      event.target.validity.valid === true
    ) {
      setValues({ ...values, [name]: event.target.value });
    } else if (event.target.validity === undefined) {
      setValues({ ...values, [name]: event.target.value });
    }
  };

  useEffect(() => {
    id === undefined
      ? setScreenName("Add New BAT Vehicle")
      : setScreenName("Edit BAT Vehicle");
    (async () => {
      getRight();
      fetchVehicleCategory();
      if (id !== undefined) {
        values._id = id;
        getBatVehicleById(
          values,
          (data) => {
            parentId = data.Result_Output[0].batGroupID;
            fetchedData = data.Result_Output[0];
            if (fetchedData) {
              setValues(fetchedData);
              setCancelBtnEdit(true);
              values.batGroupID = fetchedData.batGroupID;
              fetchRegistrationNumber(fetchedData.vehicleCategory);
            }
            setValues(data.Result_Output);
          },
          dispatch
        );
      } else {
        parentId = batGroupID;
        values.batGroupID = batGroupID;
      }
    })();
  }, [dispatch]);

  async function getRight() {
    let right = await getScreenRight("BAT Group");
    if (right === "Full Access") {
      setDisableColor(false);
    } else setDisableColor(true);
  }

  const clearErrorStates = () => {
    setVehicleCategoryErr(false);
    setRegistrationNumberErr(false);
  };

  const addNewBatVehicle = async () => {
    sessionStorage.setItem("PARA_TABLE", "BATVehicles");
    let mandateFlag = false;
    clearErrorStates();
    mandateFlag =
      validateField(values.vehicleCategory, setVehicleCategoryErr) ||
      mandateFlag;
    mandateFlag =
      validateField(values.registrationNumber, setRegistrationNumberErr) ||
      mandateFlag;
    if (mandateFlag) {
      return;
    }

    if (id === "" || id === undefined) {
      values.batGroupID = batGroupID;
      addBatVehicle(
        values,
        (data) => {
          showResMsg(
            data.Result_Status ? genericMessage.added : data.Result_Message,
            1000,
            data.Result_Status,
            navigate,
            "/batGroup/editBATGroup/" + batGroupID
          );
        },
        dispatch
      );
    } else {
      values._id = id;
      updateBatVehicle(
        values,
        (data) => {
          showResMsg(
            data.Result_Status ? genericMessage.updated : data.Result_Message,
            1000,
            data.Result_Status,
            navigate,
            "/batGroup/editBATGroup/" + parentId
          );
        },
        dispatch
      );
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const handleKeyDown = (e) => {
    const inputElement = document.querySelector(".GoogleInput");
    if (e.key === "Enter" && inputElement && inputElement.contains(e.target)) {
      e.preventDefault();
    }
  };

  useEffect(() => {
    function handleTabsOrientation() {
      return window.innerWidth < breakpoints.values.sm
        ? setTabsOrientation("vertical")
        : setTabsOrientation("horizontal");
    }
    window.addEventListener("resize", handleTabsOrientation);
    handleTabsOrientation();
    return () => window.removeEventListener("resize", handleTabsOrientation);
  }, [tabsOrientation]);

  const fetchVehicleCategory = async () => {
    getParameterListName(async (data1) => {
      for (let data of data1.Result_Output) {
        if (data.parameterName === "Vehicle Category") {
          setCategory(
            await generateDataList(
              data.parameterList,
              "_id",
              "parameterListName"
            )
          );
        }
      }
    });
  };

  useEffect(() => {
    if (values.vehicleCategory !== undefined && values.vehicleCategory !== "") {
      VC_Id = values.vehicleCategory;
      fetchRegistrationNumber(VC_Id);
      setValues((prevValues) => ({
        ...prevValues,
        registrationNumber: "",
        engineNumber: "",
        vehicleMakeModel: "",
        vinChassisNumber: "",
        vehicleManufacturingYear: "",
      }));
    }
  }, [values.vehicleCategory]);

  const fetchRegistrationNumber = async (id) => {
    values.vehicleCategory = id;
    fetchRegistrationNumberData(values, async (data) => {
      if (data.Result_Output.length > 0) {
        setRegistration(
          await generateDataList(
            data.Result_Output,
            "registrationNumber",
            "registrationNumber"
          )
        );
      } else {
        setRegistration([]);
      }
    });
  };

  useEffect(() => {
    if (
      values.registrationNumber !== undefined &&
      values.vehicleCategory !== undefined &&
      values.vehicleCategory !== "" &&
      values.registrationNumber !== ""
    ) {
      fetchDetailsByRegistration(values);
    }
  }, [values.registrationNumber, values.vehicleCategory]);

  const fetchDetailsByRegistration = async (val) => {
    fetchDetailsByRegistrationData(val, async (data) => {
      if (data.Result_Output.length > 0) {
        setValues(data.Result_Output[0]);
      }
    });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Height val={30} />
      <Card>
        <MDBox
          mx={2}
          mt={-3}
          mb={1.5}
          py={2}
          px={2}
          variant="gradient"
          bgColor={sidenavColor}
          borderRadius="lg"
          coloredShadow="info"
        >
          <MDTypography variant="h6" color="white">
            {screenName}
          </MDTypography>
        </MDBox>
        <MDBox mt={2} mb={3}>
          <Grid container spacing={2}>
            <Grid item xs={12} spacing={6}>
              <Card sx={{ boxShadow: "none" }}>
                <MDBox pt={2} px={3}>
                  <Grid container columnSpacing={5}>
                    <Grid item xs={12} lg={4}>
                      <MDBox mb={4} xs={12}>
                        <FormControl fullWidth>
                          <InputLabel id="demo-simple-select-label">
                            Vehicle Category
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            style={{ minHeight: "44.11px" }}
                            label="Vehicle Category"
                            autoFocus={true}
                            onChange={handleChange("vehicleCategory")}
                            value={values.vehicleCategory}
                          >
                            {category}
                          </Select>
                        </FormControl>
                        {vehicleCategoryErr ? (
                          <span style={errMsg}>
                            Vehicle Category can't be blank
                          </span>
                        ) : (
                          ""
                        )}
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={4}>
                      <MDBox mb={4} xs={12}>
                        <FormControl fullWidth>
                          <InputLabel id="demo-simple-select-label">
                            Registration Number
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            style={{ minHeight: "44.11px" }}
                            label="Registration Number"
                            onChange={handleChange("registrationNumber")}
                            value={values.registrationNumber}
                          >
                            {registration}
                          </Select>
                        </FormControl>
                        {registrationNumberErr ? (
                          <span style={errMsg}>
                            Registration Number can't be blank
                          </span>
                        ) : (
                          ""
                        )}
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={4}>
                      <MDBox component="form" role="form">
                        <MDBox mb={4} xs={12}>
                          <TextField
                            type="text"
                            label="Vehicle Make Model"
                            variant="outlined"
                            fullWidth
                            onChange={handleChange("vehicleMakeModel")}
                            value={values.vehicleMakeModel}
                            disabled
                          />
                        </MDBox>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={4}>
                      <MDBox component="form" role="form">
                        <MDBox mb={4} xs={12}>
                          <TextField
                            type="text"
                            label="Vehicle Manufacturing Year"
                            maxLength="20"
                            variant="outlined"
                            fullWidth
                            pattern="^[a-zA-Z0-9]+$"
                            onChange={handleChange("vehicleManufacturingYear")}
                            value={values.vehicleManufacturingYear}
                            disabled
                          />
                        </MDBox>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={4}>
                      <MDBox component="form" role="form">
                        <MDBox mb={4} xs={12}>
                          <TextField
                            type="text"
                            label="VIN/Chassis Number"
                            variant="outlined"
                            fullWidth
                            onChange={handleChange("vinChassisNumber")}
                            value={values.vinChassisNumber}
                            disabled
                          />
                        </MDBox>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={4}>
                      <MDBox component="form" role="form">
                        <MDBox mb={4} xs={12}>
                          <TextField
                            type="text"
                            label="Engine Number"
                            variant="outlined"
                            fullWidth
                            maxLength="50"
                            onChange={handleChange("engineNumber")}
                            value={values.engineNumber}
                            disabled
                          />
                        </MDBox>
                      </MDBox>
                    </Grid>
                  </Grid>
                </MDBox>
              </Card>
            </Grid>
          </Grid>
          <Grid
            container
            mt={2}
            columnSpacing={4}
            alignItems="center"
            display="flex"
            justifyContent="center"
          >
            <Grid item xs={12} md={4} spacing={2} lg={1.2}>
              <Link to={`/batGroup/editBATGroup/${parentId}`}>
                <MDButton
                  className="btn-block center-container-btn btn-warning btn-back rightSpace"
                  color="warning"
                  fullWidth
                  // onClick={cancel}
                  onClick={() => {
                    sessionStorage.setItem("PARA_TABLE", "BATVehicles");
                  }}
                >
                  Cancel
                </MDButton>
              </Link>
            </Grid>
            <Grid item xs={12} md={4} spacing={2} lg={1.2}>
              <MDButton
                onClick={disableColor ? blank : addNewBatVehicle}
                rel="noreferrer"
                variant="gradient"
                className={
                  "btn-block center-container-btn btn-warning btn-back rightSpace"
                }
                color={disableColor ? "secondary" : "success"}
                fullWidth
              >
                {id !== undefined ? <>Update</> : <>Save</>}
              </MDButton>
            </Grid>
          </Grid>
        </MDBox>
      </Card>
    </DashboardLayout>
  );
}

export default AddBATVehicle;
